import Tasks from 'APP/Tasks';
import { UpdateReason } from 'APP/constants/scroll';
import { VoiceTranscriptionStatus } from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function transcribeVoiceMessage(message: ChatMessage): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(message.groupId);
  if (!group) {
    return;
  }

  if (message.payload.transcriptionStatus === VoiceTranscriptionStatus.NotTranscribed) {
    try {
      message.payload.setTranslationStatus(VoiceTranscriptionStatus.InProgress);
      const newMessage = await messageModel.transcribeVoiceMessage(group.id, message.id);

      if (newMessage) {
        Tasks.messaging.updateOldOrFakeMessages({
          messages: [newMessage],
          groupId: group.id,
        });
      }
    } catch (error) {
      message.payload.setTranslationStatus(VoiceTranscriptionStatus.TranscriptionFailed);
      console.error(error);
    }
  }

  if (group?.isActive) {
    Entities.ChatStore.setScrollChanged(UpdateReason.EditMessage, {
      messageIds: [message.id],
      isAnimated: true,
    });
  }
}
